
export const safeJsonParse = (inputStr) => {
    try {
        return JSON.parse(inputStr)
    } catch (error) {
        return null;
    }
}